export default "__VITE_ASSET__ac41082a__"